export * from './ProductDetailsIngredientCardWrapper';
